/* Pelux · Cross-sell — comportement d'ajout au panier de snippets/pelux-cross-sell.liquid.
 *
 * ⚠️ Pourquoi ce fichier existe, et pourquoi il ne doit PAS retourner dans le snippet :
 * le tiroir panier est réécrit intégralement après chaque ajout (Section Rendering API).
 * Un <script> réinjecté par innerHTML ne s'exécute jamais — l'upsell « On ajoute ça ? »
 * était donc mort sur 100 % des clients qui venaient d'ajouter un produit, c'est-à-dire
 * exactement le moment pour lequel il a été conçu. Le clic n'émettait aucune requête,
 * aucun message : le client en déduisait simplement que le site était cassé.
 *
 * Un custom element, lui, est ré-attaché automatiquement par le navigateur à chaque
 * réécriture du DOM. C'est la seule construction qui survit au tiroir.
 *
 * Chargé depuis layout/theme.liquid — surtout pas depuis le snippet, sinon le problème
 * se reproduit à l'identique.
 */
if (!customElements.get('pelux-cross-sell')) {
  customElements.define(
    'pelux-cross-sell',
    class extends HTMLElement {
      connectedCallback() {
        // connectedCallback peut se rejouer (déplacement dans le DOM) : on ne branche qu'une fois.
        if (this.dataset.bound === '1') return;
        this.dataset.bound = '1';

        this.btn = this.querySelector('[data-pelux-crosssell-add]');
        if (!this.btn) return;
        this.btn.addEventListener('click', () => this.add());
      }

      get racine() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      add() {
        const id = Number(this.dataset.variantId);
        if (!id || this.btn.disabled) return;

        this.btn.disabled = true;
        this.btn.classList.add('is-loading');

        // Même motif que sections/pelux-sticky-atc.liquid : on demande à Shopify de
        // re-rendre les sections du tiroir dans la réponse, pour rester DANS le tiroir.
        const drawer = document.querySelector('cart-drawer');
        const sections =
          drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];

        fetch(this.racine + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: id, quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((res) => {
            this.btn.disabled = false;
            this.btn.classList.remove('is-loading');
            if (res && res.status) return; // refus d'ajout (rupture, limite) : on ne navigue pas
            if (drawer && res && res.sections && drawer.renderContents) {
              // Le thème est en mode tiroir : on y reste. Éjecter le client vers /cart
              // au moment où il s'apprête à payer est une sortie de tunnel gratuite.
              drawer.renderContents(res);
              if (drawer.open) drawer.open();
            } else {
              window.location = this.racine + 'cart';
            }
          })
          .catch(() => {
            this.btn.disabled = false;
            this.btn.classList.remove('is-loading');
          });
      }
    }
  );
}
